import React, {useState, useEffect, useCallback} from 'react'
import { 
  Spinner,
  IconButton,
  Typography,
  Input,
  Progress
} from '@material-tailwind/react';
import { v4 as uuidv4 } from 'uuid';
const { io } = require('socket.io-client');
import { useParams } from 'react-router-dom';
import TapIndexer from '../components/Indexer/TapIndexer';
import DmtIndexer from '../components/Indexer/DmtIndexer';
import UnatIndexer from '../components/Indexer/UnatIndexer';
import Scr20Indexer from '../components/Indexer/Scr20Indexer';
import StampIndexer from '../components/Indexer/StampIndexer';
import Cat20Indexer from '../components/Indexer/Cat20Indexer';
import Lrc20Indexer from '../components/Indexer/Lrc20Indexer';
import RunesIndexer from '../components/Indexer/RunesIndexer';
import Dust20Indexer from '../components/Indexer/Dust20Indexer';
import Op20Indexer from '../components/Indexer/Op20Indexer';
import Op20NameIndexer from '../components/Indexer/Op20NameIndexer';
import MezcalIndexer from '../components/Indexer/MezcalIndexer';
import Dropdown from '../components/Dropdown';

export default function IndexPage() {
  const { param } = useParams();
  const [tab, setTab] = useState(param != "" && param != undefined ? 7 : 9);
  const dropdownTabs = ["TAP", "DMT", "UNAT", "SRC20", "STAMPS", "CAT20", "LRC20", "RUNES", "DUST20", "OP20", "OP_NAMES", "MEZCAL", "BLOCK20"];

  const [activeDropDown, setActiveDropDown] = useState("OP20");

  useEffect(() => {
    switch (activeDropDown) {
      case "TAP":
        setTab(0);
        break;
      case "DMT":
        setTab(1);
        break;
      case "UNAT":
        setTab(2);
        break;
      case "SRC20":
        setTab(3);
        break;
      case "STAMPS":
        setTab(4);
        break;
      case "CAT20":
        setTab(5);
        break;
      case "LRC20":
        setTab(6);
        break;
      case "RUNES":
        setTab(7);
        break;
      case "DUST20":
        setTab(8);
        break;
      case "OP20":
        setTab(9);
        break;
      case "OP_NAMES":
        setTab(10);
        break;
      case "MEZCAL":
        setTab(11);
        break;
      case "BLOCK20":
        showBlock20Indexer();
        break;
    }
  }, [activeDropDown])

  const showBlock20Indexer = () => {
    window.open('https://block20.wtf', '_blank');
  }

  return (
    <div className="text-white mt-[65px] w-full max-w-[1500px] md:px-7 px-2 flex flex-col items-center mb-10 min-h-[600px]">
      <div className="sm:flex hidden flex-wrap sm:gap-8 gap-3 w-full mt-5">
        <div className={`sm:text-[20px] text-[16px] ${tab == 0 ? 'text-primary border-b-[2px] border-b-primary border-b-solid' : ''} hover:text-primary pb-1 cursor-pointer`} onClick={() => setTab(0)}>TAP</div>
        <div className={`sm:text-[20px] text-[16px] ${tab == 1 ? 'text-primary border-b-[2px] border-b-primary border-b-solid' : ''} hover:text-primary pb-1 cursor-pointer`} onClick={() => setTab(1)}>DMT</div>
        <div className={`sm:text-[20px] text-[16px] ${tab == 2 ? 'text-primary border-b-[2px] border-b-primary border-b-solid' : ''} hover:text-primary pb-1 cursor-pointer`} onClick={() => setTab(2)}>UNAT</div>
        <div className={`sm:text-[20px] text-[16px] ${tab == 3 ? 'text-primary border-b-[2px] border-b-primary border-b-solid' : ''} hover:text-primary pb-1 cursor-pointer`} onClick={() => setTab(3)}>SRC20</div>
        <div className={`sm:text-[20px] text-[16px] ${tab == 4 ? 'text-primary border-b-[2px] border-b-primary border-b-solid' : ''} hover:text-primary pb-1 cursor-pointer`} onClick={() => setTab(4)}>STAMPS</div>
        <div className={`sm:text-[20px] text-[16px] ${tab == 5 ? 'text-primary border-b-[2px] border-b-primary border-b-solid' : ''} hover:text-primary pb-1 cursor-pointer`} onClick={() => setTab(5)}>CAT20</div>
        <div className={`sm:text-[20px] text-[16px] ${tab == 6 ? 'text-primary border-b-[2px] border-b-primary border-b-solid' : ''} hover:text-primary pb-1 cursor-pointer`} onClick={() => setTab(6)}>LRC20</div>
        <div className={`sm:text-[20px] text-[16px] ${tab == 7 ? 'text-primary border-b-[2px] border-b-primary border-b-solid' : ''} hover:text-primary pb-1 cursor-pointer`} onClick={() => setTab(7)}>RUNES</div>
        <div className={`sm:text-[20px] text-[16px] ${tab == 8 ? 'text-primary border-b-[2px] border-b-primary border-b-solid' : ''} hover:text-primary pb-1 cursor-pointer`} onClick={() => setTab(8)}>DUST20</div>
        <div className={`sm:text-[20px] text-[16px] ${tab == 9 ? 'text-primary border-b-[2px] border-b-primary border-b-solid' : ''} hover:text-primary pb-1 cursor-pointer`} onClick={() => setTab(9)}>OP20</div>
        <div className={`sm:text-[20px] text-[16px] ${tab == 10 ? 'text-primary border-b-[2px] border-b-primary border-b-solid' : ''} hover:text-primary pb-1 cursor-pointer`} onClick={() => setTab(10)}>OP_NAMES</div>
        <div className={`sm:text-[20px] text-[16px] ${tab == 11 ? 'text-primary border-b-[2px] border-b-primary border-b-solid' : ''} hover:text-primary pb-1 cursor-pointer`} onClick={() => setTab(11)}>MEZCAL</div>
        <div className={`sm:text-[20px] text-[16px] ${tab == 12 ? 'text-primary border-b-[2px] border-b-primary border-b-solid' : ''} hover:text-primary pb-1 cursor-pointer`} onClick={() => showBlock20Indexer()}>BLOCK20</div>
      </div>
      <div className="sm:hidden flex flex-row gap-3 w-full items-center mt-5">
        <Dropdown tabs = {dropdownTabs} setActiveDropDown = {setActiveDropDown} activeDropDown = {activeDropDown}/>
        <div className={`text-[18px] w-full text-center px-2 py-2 bg-primary hover:bg-primary-hover cursor-pointer text-white rounded-md`} onClick={() => {setTab(9); setActiveDropDown("OP20")}}>OP20</div>
      </div>

      {
        tab == 0 ? <TapIndexer />: <></>
      }
      {
        tab == 1 ? <DmtIndexer /> : <></>
      }
      {
        tab == 2 ? <UnatIndexer /> : <></>
      }
      {
        tab == 3 ? <Scr20Indexer /> : <></>
      }
      {
        tab == 4 ? <StampIndexer /> : <></>
      }
      {
        tab == 5 ? <Cat20Indexer /> : <></>
      }
      {
        tab == 6 ? <Lrc20Indexer /> : <></>
      }
      {
        tab == 7 ? <RunesIndexer param = {param}/> : <></>
      }
      {
        tab == 8 ? <Dust20Indexer /> : <></>
      }
      {
        tab == 9 ? <Op20Indexer /> : <></>
      }
      {
        tab == 10 ? <Op20NameIndexer /> : <></>
      }
      {
        tab == 11 ? <MezcalIndexer /> : <></>
      }
    </div>
  )
}
